import { getObject, postObject, deleteObject } from "../ChoiceApi";

export async function getCodeGroupXrefList(diagnosisCodeGroupId: number) : Promise<DiagnosisCodeGroupXrefItem[] | undefined>
{
    return await getObject(`api/Setup/Diagnosis/CodeGroupXrefList/${diagnosisCodeGroupId}`);
}
export async function saveCodeGroup(payload: DiagnosisCodeGroupSaveInputs): Promise<DiagnosisCodeGroupSaveResult | undefined> 
{
    return (await postObject("api/Setup/Diagnosis/CodeGroupSave", payload));   
} 
export async function getCodeGroupList() : Promise<DiagnosisCodeGroupItem[] | undefined>
{
    return await getObject(`api/Setup/Diagnosis/CodeGroupList`);
}
export async function deleteCodeGroup(diagnosisCodeGroupId: number): Promise<DiagnosisCodeGroupRemoveResult | undefined> 
{
    return await deleteObject(`api/Setup/Diagnosis/CodeGroupRemove/${diagnosisCodeGroupId}`);
}
export async function addCodeGroupXref(payload: DiagnosisCodeGroupXrefInputs): Promise<DiagnosisCodeGroupAddResult | undefined> 
{
    return (await postObject("api/Setup/Diagnosis/CodeGroupXrefAdd", payload));   
} 
export async function removeCodeGroupXref(payload: DiagnosisCodeGroupXrefInputs): Promise<boolean | undefined> 
{
    return (await postObject("api/Setup/Diagnosis/CodeGroupXrefRemove", payload));   
} 

export interface DiagnosisCodeGroupXrefItem
{
    codeId: number,
    code: string,
    codeType: string,
    codeDescription: string
}

export interface DiagnosisCodeGroupSaveInputs
{
    diagnosisCodeGroupId?: number,
    description: string
}

export interface DiagnosisCodeGroupSaveResult
{
    passed: boolean,
    diagnosisCodeGroupId?: number,
    message?: string
}

export interface DiagnosisCodeGroupItem
{
    diagnosisCodeGroupId: number,
    description: string
}

export interface DiagnosisCodeGroupRemoveResult 
{
    passed: boolean,
    message?: string
} 

export interface DiagnosisCodeGroupXrefInputs
{
    diagnosisCodeGroupId: number,
    codeList: number[]
}

export interface DiagnosisCodeGroupAddResult 
{
    passed: boolean,
    message?: string
} 